import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from "@common/interfaces/id";
import { IID_RISORSE_IRU_ACQUISIZIONE } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IRisorseIruAcquisizioneState extends EntityState<IID_RISORSE_IRU_ACQUISIZIONE, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_RISORSE_IRU_ACQUISIZIONE , realtimeEntity: 'IID_RisorseIruAcquisizione'})
@InterfaceDataStore(InterfaceName.RISORSE_IRU_ACQUISIZIONE)
export class IIDRisorseIruAcquisizioneStore extends EntityStore<IRisorseIruAcquisizioneState> {
  constructor() {
    super();
  }
}
